const UserLangs = {
  userList: {
    title: "Danh sách nhân viên",
  },
  error: {
    userList: {
      message: "Lỗi danh sách nhân viên",
    },
    reportSummary: {
      message: "Lỗi thống kê doanh thu nhân viên",
    },
  },
};
export default UserLangs;
